import { routes } from '@/router.js';

export default [
  {
    title: 'Home',
    icon: 'home',
    to: routes.home,
  },
  {
    title: 'Portfolio',
    icon: 'face',
    to: routes.portfolio,
  },
  {
    title: 'Photography',
    icon: 'collections',
    to: routes.photography,
  },
  {
    title: 'LoremIpsum',
    icon: 'mode_comment',
    to: routes.blog,
  },
];
